import _ from 'lodash';

import { MAX_PERCENTAGE_VALUE } from 'constants/number';
import { jsonStringify } from 'utils/json';

import { AI_QUESTION_CARD_LABELS, QUESTION_TYPE } from './AiQuestionCard.constants';

export const getQuestionType = question => {
  if (_.isEmpty(question?.options)) {
    return QUESTION_TYPE.FREE_TEXT;
  }

  return question.multiSelect ? QUESTION_TYPE.MULTI_SELECT : QUESTION_TYPE.SINGLE_SELECT;
};

export const hasAnswer = value => {
  if (_.isArray(value)) {
    return value.length > 0;
  }

  if (_.isString(value)) {
    return value.trim().length > 0;
  }

  return !_.isNil(value);
};

export const getAnswerSummary = value => {
  if (!hasAnswer(value)) {
    return AI_QUESTION_CARD_LABELS.SKIPPED_SUMMARY;
  }

  if (_.isArray(value)) {
    return value.join(', ');
  }

  return value;
};

export const getProgressLabel = (currentIndex, total) => `Question ${currentIndex + 1} of ${total}`;

export const getProgressValue = (currentIndex, total) =>
  total > 0 ? ((currentIndex + 1) / total) * MAX_PERCENTAGE_VALUE : 0;

export const buildAnswersJson = (questions, answers) => {
  const prunedAnswers = questions.reduce((accumulator, question) => {
    const value = answers[question.header];

    return hasAnswer(value) ? { ...accumulator, [question.header]: value } : accumulator;
  }, {});

  return jsonStringify({ answers: prunedAnswers });
};
